import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'tipoAbierta',
  templateUrl: './abierta.component.html',
  styleUrls: ['./abierta.component.scss']
})
export class AbiertaComponent implements OnInit {

  @Input('textoEntrada') textoEntrada?: string;
  @Input('pasoCompleto') pasoCompleto?: boolean;
  @Output() textoPregunta: EventEmitter<string> = new EventEmitter();
  @Output() guardaPreguntaBD: EventEmitter<boolean> = new EventEmitter();

  constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService)
  {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
  }

  // colocaTextoEntrada(){
  //   if(this.textoEntrada){
  //
  //   }
  // }

  borrarPregunta(){

  }

  guardaPregunta(){
    this.guardaPreguntaBD.emit(true);
  }

  enviaTextoPregunta(event){

    this.textoPregunta.emit(event.target.value);
  }

}
